import React from 'react';
import type { PolicySection } from '../../types/policy';
const linkStyles = 'text-purple-700 underline underline-offset-2 decoration-purple-300 hover:decoration-purple-700 hover:text-purple-900 transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-ivory rounded';
interface PolicySectionBodyProps {
  section: PolicySection;
}
export function PolicySectionBody({
  section
}: PolicySectionBodyProps) {
  return <section id={section.id} aria-labelledby={`${section.id}-heading`} className="scroll-mt-40 lg:scroll-mt-32 pt-12 first:pt-0" data-id="element-287" data-mp="b97q90tol1z0">
      <h2 id={`${section.id}-heading`} className="font-serif text-2xl md:text-3xl text-charcoal leading-snug border-l-2 border-purple-600 pl-5" data-id="element-288" data-mp="2f32wrdra8o8">
        <span className="text-purple-700" data-id="element-289" data-mp="3jpjaexd07ty0">{section.number}.</span>{' '}
        {section.title}
      </h2>

      <div className="mt-6 space-y-6" data-id="element-290" data-mp="3oodue2mpjojp">
        {section.blocks.map((block, index) => {
        switch (block.kind) {
          case 'sub':
            return <h3 key={index} className="font-serif text-lg md:text-xl text-purple-800 pt-4 pb-2 border-b border-purple-100" data-id="element-291" data-mp="3gs7c06q1b4d9">
                  <span className="tabular-nums" data-id="element-292" data-mp="3qs7whvzn3qj1">{block.number}</span>{' '}
                  {block.title}
                </h3>;
          case 'lead':
            return <p key={index} className="text-base font-semibold text-charcoal leading-relaxed" data-id="element-293" data-mp="2y3ac9nbvbjnn">
                  {block.text}
                </p>;
          case 'p':
            return <p key={index} className="text-base text-charcoal/80 leading-[1.8]" data-id="element-294" data-mp="2jd34q2nefl1q">
                  {block.text}
                </p>;
          case 'ul':
            return <ul key={index} className="space-y-3 pl-1" data-id="element-295" data-mp="iakei9w8f1w7">
                  {block.items.map((item, itemIndex) => <li key={itemIndex} className="relative pl-6 text-base text-charcoal/80 leading-[1.8]" data-id="element-296" data-mp="n83q121jp0kg" data-mpi={itemIndex}>
                      <span aria-hidden="true" className="absolute left-0 top-[0.7em] h-1.5 w-1.5 rounded-full bg-purple-500" data-id="element-297" data-mp="wzgk80atg2tn" />
                      {item.lead ? <>
                          <strong className="font-semibold text-charcoal" data-id="element-298" data-mp="99vzpcz0kxi9">
                            {item.lead}
                          </strong>{' '}
                          {item.text}
                        </> : item.text}
                    </li>)}
                </ul>;
          case 'clause':
            return <p key={index} className="relative pl-14 text-base text-charcoal/80 leading-[1.8]" data-id="element-299" data-mp="3a66g28ryzz3i">
                  <span className="absolute left-0 font-semibold tabular-nums text-charcoal" data-id="element-300" data-mp="30gmswqx85j2u">
                    {block.number}
                  </span>
                  {block.lead ? <>
                      <strong className="font-semibold text-charcoal" data-id="element-301" data-mp="2qiyyy37g0flq">
                        {block.lead}
                      </strong>{' '}
                    </> : null}
                  {block.text}
                </p>;
          case 'contact':
            return <address key={index} className="not-italic rounded-2xl border border-purple-200 bg-purple-50 px-6 py-5" data-id="element-302" data-mp="2cjzaownue2q3">
                  <p className="font-serif text-base text-charcoal mb-3" data-id="element-303" data-mp="ar2runnoxvvf">
                    {block.title}
                  </p>
                  <ul className="space-y-1.5" data-id="element-304" data-mp="34kvp8ojyl2ml">
                    {block.lines.map((line, lineIndex) => <li key={lineIndex} className="text-base text-charcoal/80 leading-relaxed" data-id="element-305" data-mp="38kmakcqpuqjq" data-mpi={lineIndex}>
                        {line.label ? <span className="font-semibold text-charcoal" data-id="element-306" data-mp="2zimubmnizqhu">
                            {line.label}:{' '}
                          </span> : null}
                        {line.href ? <a href={line.href} className={linkStyles} {...line.href.startsWith('http') ? {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                  } : {}} data-id="element-307" data-mp="2buvhmhy2pbg1">
                            {line.value}
                          </a> : line.value}
                      </li>)}
                  </ul>
                </address>;
          default:
            return null;
        }
      })}
      </div>
    </section>;
}